import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const PrivacyPolicy = createIcon({
    displayName: 'PrivacyPolicy',
    viewBox: "0 0 24 24",
    path: [
        <g key="k1">
            <path d="M8,9c.3,0,.5,0,.7-.3.2-.2.3-.4.3-.7s0-.5-.3-.7c-.2-.2-.4-.3-.7-.3s-.5,0-.7.3c-.2.2-.3.4-.3.7s0,.5.3.7c.2.2.4.3.7.3Z" fill="currentColor" />
            <path d="M8,13c.3,0,.5,0,.7-.3.2-.2.3-.4.3-.7s0-.5-.3-.7c-.2-.2-.4-.3-.7-.3s-.5,0-.7.3c-.2.2-.3.4-.3.7s0,.5.3.7c.2.2.4.3.7.3Z" fill="currentColor" />
            <path d="M11.4,19h-6.4V5h14v6.8c.6.2,1.2.3,1.7.3h.3v-7.1c0-.5-.2-1-.6-1.4-.4-.4-.9-.6-1.4-.6H5c-.5,0-1,.2-1.4.6-.4.4-.6.9-.6,1.4v14c0,.5.2,1,.6,1.4.4.4.9.6,1.4.6h7.6c-.5-.6-.9-1.3-1.2-2Z" fill="currentColor" />
            <path d="M8,17c.3,0,.5,0,.7-.3.2-.2.3-.4.3-.7s0-.5-.3-.7c-.2-.2-.4-.3-.7-.3s-.5,0-.7.3c-.2.2-.3.4-.3.7s0,.5.3.7c.2.2.4.3.7.3Z" fill="currentColor" />
        </g>,
        <path d="M16.4,12.2c-1.2,1-2.8,1.5-4.4,1.4-.1,4.8,1.6,7.3,4.4,8.3,2.9-1.1,4.6-3.8,4.4-8.3-1.3.1-2.8-.4-4.4-1.4Z" fill="currentColor" key="k2" />
    ]
})

